export class EventBus {
  private static instance: EventBus;
  private listeners: { [eventName: string]: Function[] } = {};

  private constructor() {}
 
  public static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
    }
    return EventBus.instance;
  }

  public subscribe(eventName: string, callback: Function): void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }

    // Check if the callback is already subscribed
    if (!this.listeners[eventName].includes(callback)) {
      this.listeners[eventName].push(callback);
    }
  }

  public unsubscribe(eventName: string, callback: Function): void {
    if (!this.listeners[eventName]) return;

    this.listeners[eventName] = this.listeners[eventName].filter((cb) => cb !== callback);
  }

  public publish(eventName: string, data: any): void {
    if (!this.listeners[eventName]) return;

    this.listeners[eventName].forEach((callback) => callback(data));
  }

  public static Event = {
    OnSiteSelected: "OnSiteSelected",
    OnNewSiteAdded: "OnNewSiteAdded",
    OnSiteRemoved: "OnSiteRemoved",
    OnAccountUpdated: "OnAccountUpdated",
    
    OnTreeNodeSelect: "OnTreeNodeSelect",
    OnAddPageVersion: "OnAddPageVerion",
    OnDeletePage: "OnDeletePage",

    OnSocialMediaSignIn: "OnSocialMediaSignIn",
    OnSocialMediaPublishingConnected: "OnSocialMediaPublishingConnected"
  }
}
